import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import Layout from '../../templates/Layout';
import H1 from '../../atoms/title/H1';
import Panel from '../../atoms/Panel';
import { Col, Row } from 'react-grid-system';
import PersonalDetails from '../../molecules/form/PersonalDetails';
import Button from '../../atoms/Button';
import AddUserIcon from '../../atoms/icons/AddUserIcon';
import Flex from '../../atoms/Flex';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { useForm } from '@inertiajs/react';
import Notice from '../../molecules/Notice';
const StyledWrapper = styled.div `
    margin-bottom: 50px;
`;
const initialData = {
    full_name: '',
    email: '',
};
const Create = ({ emailDomain, propNotice, }) => {
    const { t } = useTranslation();
    const { data, setData, post, processing, errors, reset, transform, } = useForm(initialData);
    const [notice, setNotice] = useState(propNotice);
    useEffect(() => {
        setNotice(propNotice);
    }, [propNotice]);
    transform(data => ({
        ...data,
        email: data.email + '@' + emailDomain,
    }));
    const handleSubmit = (e) => {
        e.preventDefault();
        try {
            post(window.location.href, {
                onSuccess: result => {
                    if (result.props.notice) {
                        setNotice(result.props.notice);
                    }
                    reset();
                },
            });
        }
        catch (e) {
            setNotice({
                type: 'error',
                text: t('add_user.default_error_notice'),
                title: 'Fout',
            });
        }
    };
    return (_jsxs(Layout, { "data-testid": "user-create", children: [_jsx(Helmet, { children: _jsx("title", { children: t('add_user.title') }) }), _jsx(H1, { "data-testid": "title", children: t('add_user.title') }), _jsx("form", { action: "./", method: 'post', onSubmit: handleSubmit, children: _jsxs(Panel, { children: [notice && _jsx(Notice, { ...notice }), _jsx(Row, { children: _jsx(Col, { sm: 12, children: _jsx(StyledWrapper, { children: _jsx(PersonalDetails, { data: data, errors: errors, setData: setData, emailDomain: emailDomain, disabled: processing, emailInputDisabled: false }) }) }) }), _jsxs(Row, { children: [_jsx(Col, { sm: 7 }), _jsx(Col, { sm: 5, children: _jsx(Flex, { column: true, justifyContent: "space-between", children: _jsx(Button, { type: "submit", alignSelf: "flex-end", secondary: true, icon: _jsx(AddUserIcon, {}), isLoading: processing, children: t('add_user.button') }) }) })] })] }) })] }));
};
export default Create;
